import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Layout from "../../components/lb/layout";

const IndexPage = () => {

	var seo = { metaTitle:'Startsait | Dapit', metaDescription:'Startsait vun Dapit klengen Portfolio Sait.', shareImage:"/images/LandingPage-Dapit.png"};

	return (
		<Layout pageen="/" pagelb="/" seo={seo}>
			<section className="call4Action">
				<div className="box">
					<div className="title">
						<h1>
							Dylan Mertz<br/>
							Dapit<br/>
							En klengen Portfolio
						</h1>
					</div>
					<button className="call4Action-contact">
						<a href="/lb/kontakt">Kontakt</a>
					</button>
					<button className="call4Action-works">
						<a href="#nocturnal">Meng Projeten</a>
					</button>
				</div>
				<div className="karbs d-flex justify-content-end justify-content-lg-between">
					<img src="/images/roseshape.svg" alt="Image, Banner Image of Karbs swimming."/>
					<img src="/images/karbs.svg" alt="Image, Banner Image of Karbs swimming."/>
				</div>
			</section>
			<section className="container-fluid block mt-5 mb-5" id="nocturnal">
				<div className="row mt-5">
					<div className="col-12 col-lg-5 title">
						<p className="date">20 Aprël 2021</p>
						<h2>Nocturnal E-Sports A.S.B.L</h2>
						<div className="d-none d-lg-inline">
							<h3>Websait</h3>
							<p>
								Nocturnal E-Sports nei Websäit ass eng Plattform wou se hir Neiegkeeten posten a wou Dir detailléiert Informatiounen iwwer hir Teams an de verschiddenen E-Sporte fannt. Iwwer dës Equipen fannt Dir detailléiert Informatioun iwwer den Tournoi mat hirem Resultat an deem se konkurréieren.
							</p>
							<p>
								D'Säit féiert och hir Memberen vir a wat se maachen.
							</p>
							<ul>
								<li>
									<a href="http://www.nocturnal.lu" target="_blank">
										<i className="fas fa-globe"></i>
									</a>
								</li>
								<li>
									<a href="http://www.nocturnal.lu" target="_blank">
										<i className="fab fa-instagram"></i>
									</a>
								</li>
								<li>
									<a href="http://www.nocturnal.lu" target="_blank">
										<i className="fab fa-facebook-square"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="col-12 col-lg-7 image">
						<img src="/images/Nocturnal-Website.jpg" alt="Image, Nocturnal E-sports Screenshot of the website's landing page."/>
						<div className="caption">
							<div className="box">
								<span className="header">Nocturnal E-sport</span><br/>
								'Startsait'
							</div>
						</div>
					</div>
					<div className="col-12 d-inline d-lg-none content">
						<h3>Websait</h3>
						<p>
							Nocturnal E-Sports nei Websäit ass eng Plattform wou se hir Neiegkeeten posten a wou Dir detailléiert Informatiounen iwwer hir Teams an de verschiddenen E-Sporte fannt. Iwwer dës Equipen fannt Dir detailléiert Informatioun iwwer den Tournoi mat hirem Resultat an deem se konkurréieren.
						</p>
						<p>
							D'Säit féiert och hir Memberen vir a wat se maachen.
						</p>
						<ul>
							<li>
								<a href="http://www.nocturnal.lu" target="_blank">
									<i className="fas fa-globe"></i>
								</a>
							</li>
							<li>
								<a href="http://www.nocturnal.lu" target="_blank">
									<i className="fab fa-instagram"></i>
								</a>
							</li>
							<li>
								<a href="http://www.nocturnal.lu" target="_blank">
									<i className="fab fa-facebook-square"></i>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</section>
			<section className="container-fluid block mb-5">
				<div className="row">
					<div className="col-12 col-lg-5 order-lg-2 title">
						<p className="date">09 Dezember 2020</p>
						<h2>MX-5 NA am Owend</h2>
						<div className="d-none d-lg-inline">
							<h3>Photografie</h3>
							<p>
								Shooting fir de Sacha mat sengem relative neie Schatz vun engem alen Mazda Mx-5 NA aus dem Joer 1996.
							</p>
							<ul>
								<li>
									<a href="http://www.nocturnal.lu" target="_blank">
										<i className="fab fa-instagram"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="col-12 col-lg-7 order-lg-1 image">
						<div className="carousel slide carousel-fade" id="mx5Carousel" data-bs-ride="carousel" data-bs-interval="false">
							<div className="carousel-inner">
								<div className="carousel-item active">
									<img src="/images/mx5-first-night-1.jpg" alt="Image, MX5-Na night shooting"/>
								</div>
								<div className="carousel-item">
									<img src="/images/mx5-first-night-2-v2.jpg" alt="Image, MX5-Na night shooting"/>
								</div>
								<div className="carousel-item">
									<img src="/images/mx5-first-night-5.jpg" alt="Image, MX5-Na night shooting"/>
								</div>
								<div className="carousel-item">
									<img src="/images/mx5-first-night-6.jpg" alt="Image, MX5-Na night shooting"/>
								</div>
							</div>
						</div>
						<div className="caption">
							<div className="box">
								<span className="header">MX-5 NA</span><br/>
								'Owes Photoshoot'
							</div>
						</div>
						<div className="carousel-control-box">
							<button className="carousel-control carousel-control-prev" type="button" data-bs-target="#mx5Carousel" data-bs-slide="prev">
								<i class="fas fa-caret-left"></i>
							</button>
							<button className="carousel-control carousel-control-next" type="button" data-bs-target="#mx5Carousel" data-bs-slide="next">
								<i class="fas fa-caret-right"></i>
							</button>
						</div>
					</div>
					<div className="col-12 d-inline d-lg-none content">
						<h3>Photografie</h3>
						<p>
							Shooting fir de Sacha mat sengem relative neie Schatz vun engem alen Mazda Mx-5 NA aus dem Joer 1996.
						</p>
						<ul>
							<li>
								<a href="http://www.nocturnal.lu" target="_blank">
									<i className="fab fa-instagram"></i>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</section>
			<section className="container-fluid block more mb-5">
				<div className="">
					<div className="col-12 more">
						<a href="/lb/portfolio">All meng Projeten</a>
					</div>
				</div>
			</section>
		</Layout>
	);
};

export default IndexPage;
